module.exports = __webpack_public_path__ + "img/mutua-ulisse-no-bg.98dfbd1f.png";